// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_9e1425b4d3--checkbox--ExCwZ"};